module.exports = __webpack_public_path__ + "static/media/1009866.8d0ea808.jpg";